const scoreRules = [
  { direction: 'gt', value: 2, backgroundColor: '#5ec871' },
  { direction: 'gte', value: 0, backgroundColor: '#e8f7eb' },
  { direction: 'lt', value: -2, backgroundColor: '#e26067' },
  { direction: 'lt', value: 0, backgroundColor: '#eea4a8' }
];
export const columns = [
  {
    field: 'topic',
    label: 'Topic',
    fixed: true,
    sortable: false,
    width: 200,
    type: 'link'
    //Cell: renderCell
  },
  {
    label: 'Last 6 Months',
    isGroup: true,
    width: 600,
    sortable: false,
    columns: [
      {
        field: 'may',
        label: 'May',
        width: 80,
        type: 'score',
        sortable: true,
        rules: scoreRules
        //Cell: renderCell
      },
      {
        field: 'jun',
        label: 'Jun',
        width: 80,
        type: 'score',
        sortable: true,
        rules: scoreRules
        //Cell: renderCell
      },
      {
        field: 'jul',
        label: 'Jul',
        width: 80,
        type: 'score',
        sortable: true,
        rules: scoreRules
        //Cell: renderCell
      },
      {
        field: 'aug',
        label: 'Aug',
        width: 80,
        type: 'score',
        sortable: true,
        rules: scoreRules
        //Cell: renderCell
      },
      {
        field: 'sep',
        label: 'Sep',
        width: 80,
        type: 'score',
        sortable: true,
        rules: scoreRules
        //Cell: renderCell
      },
      {
        field: 'oct',
        label: 'Oct',
        width: 80,
        type: 'score',
        sortable: true,
        rules: scoreRules
        //Cell: renderCell
      },
      {
        field: 'nov',
        label: 'Nov',
        width: 80,
        type: 'score',
        sortable: true,
        rules: scoreRules
        //Cell: renderCell
      },
      {
        field: 'total',
        label: 'Total',
        width: 80,
        type: 'score',
        rules: scoreRules
        //Cell: renderCell
      }
    ]
  },
  {
    label: 'Same Period Year Ago',
    isGroup: true,
    width: 180,
    columns: [
      { field: 'benchmark', label: 'Benchmark', width: 90 },
      {
        field: 'delta',
        label: 'Delta',
        width: 90,
        type: 'score'
      }
    ]
  }
];

export const data = [
  {
    topic: 'Guest Room',
    may: -85.71,
    jun: -1.0,
    jul: -33.33,
    aug: -19.05,
    sep: +31.82,
    oct: -133.33,
    nov: -100.0,
    total: -61.94,
    benchmark: -4.9,
    delta: -57.04
  },
  {
    topic: 'Staff',
    may: -23.21,
    jun: -30.56,
    jul: null,
    aug: +25.65,
    sep: -18.18,
    oct: -10,
    nov: 0.0,
    total: -10.68,
    benchmark: +7.38,
    delta: -18.06,
    subData: [
      {
        topic: 'Staff - Attitude',
        may: -14.56,
        jun: -30.56,
        jul: null,
        aug: +25.65,
        sep: -18.18,
        oct: -8.33,
        total: -7.78,
        benchmark: +10.04,
        delta: -17.82
      },
      {
        topic: 'Staff - Professionalism',
        may: null,
        jun: -20.45,
        sep: -13.18,
        total: -5.75,
        benchmark: -2.41,
        delta: -3.34
      }
    ]
  }
];

export const columns2 = [
  {
    field: 'topic',
    label: 'Topic',
    fixed: true,
    width: 200,
    sortable: false,
    type: 'link'
    //Cell: renderCell
  },
  {
    field: 'responses',
    label: '% Responses',
    sortable: true,
    type: 'threshold',
    threshold: {
      value: 50,
      field: 'responsesSampleSize',
      direction: 'lt'
    }
    //Cell: renderCell
  },
  {
    field: 'positive',
    label: '% Positive',
    sortable: true,
    type: 'threshold',
    threshold: {
      value: 50,
      field: 'positiveSampleSize',
      direction: 'lt'
    }
    //Cell: renderCell
  },
  {
    field: 'negative',
    label: '% Negative',
    sortable: true,
    type: 'threshold',
    threshold: {
      value: 50,
      field: 'bennegativeSampleSizechmark',
      direction: 'lt'
    }
    //Cell: renderCell
  }
];

export const data2 = [
  {
    topic: 'Brand',
    responses: 100.0,
    responsesSampleSize: 210,
    positive: 52.86,
    positiveSampleSize: 111,
    negative: 44.29,
    negativeSampleSize: 99,

    subData: [
      {
        topic: 'Brand - Guest Relationship',
        responses: 100.0,
        responsesSampleSize: 210,
        positive: 52.86,
        positiveSampleSize: 111,
        negative: 44.29,
        negativeSampleSize: 99,

        subData: [
          {
            topic: 'Guest Relationship - Churn/Return Intention',
            responses: 97.14,
            responsesSampleSize: 204,
            positive: 53.43,
            positiveSampleSize: 109,
            negative: 45.1,
            negativeSampleSize: 95
          },
          {
            topic: 'Guest Relationship - Tenure/Frequent Guest',
            responses: 2.86,
            responsesSampleSize: 6,
            positive: 33.33,
            positiveSampleSize: 2,
            negative: 16.67,
            negativeSampleSize: 1,
            lowSampleSize: true
          }
        ]
      }
    ]
  },

  {
    topic: 'Guest Room',
    responses: 50.95,
    responsesSampleSize: 107,
    positive: 43.93,
    positiveSampleSize: 47,
    negative: 63.55,
    negativeSampleSize: 60
  },

  {
    topic: 'Property/Facilities',
    responses: 42.38,
    responsesSampleSize: 89,
    positive: 50.56,
    positiveSampleSize: 45,
    negative: 56.18,
    negativeSampleSize: 50
  },

  {
    topic: 'Services',
    responses: 38.57,
    responsesSampleSize: 81,
    positive: 53.09,
    positiveSampleSize: 43,
    negative: 45.68,
    negativeSampleSize: 38
  },

  {
    topic: 'Staff',
    responses: 37.62,
    responsesSampleSize: 79,
    positive: 72.15,
    positiveSampleSize: 57,
    negative: 27.85,
    negativeSampleSize: 22
  }
];
